/*
 * RIDECLOUD HOW IT WORKS SECTION
 * Style: Original RideCloud — white/light background, 3 step cards in a row
 * Step cards: orange "Step N" badge, orange icon, title, description
 * Cards have orange border (matching original dashed/solid orange border)
 * Colours: #2e004f headings, #e6531e step badges/icons, white bg
 */

import { ClipboardList, CheckCircle, Car } from "lucide-react";

const steps = [
  {
    number: "Step 1",
    icon: ClipboardList,
    title: "Apply online",
    desc: "Complete our quick application and upload your ID, driver's licence and proof of income. It takes a few minutes.",
  },
  {
    number: "Step 2",
    icon: CheckCircle,
    title: "Get approved",
    desc: "We confirm affordability, match you to the right car & subscription band, and finalise your contract digitally.",
  },
  {
    number: "Step 3",
    icon: Car,
    title: "Collect & Drive",
    desc: "Collect from a RideCloud partner dealership, or arrange delivery where available — and enjoy your all-inclusive car from day one.",
  },
];

export default function HowItWorks() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="how-it-works" className="py-16 md:py-20" style={{ backgroundColor: "#ffffff" }}>
      <div className="container">
        {/* Header */}
        <div className="mb-4">
          <h2 className="text-3xl md:text-4xl font-semibold mb-2" style={{ color: "#2e004f" }}>
            How It Works
          </h2>
          <p className="text-base" style={{ color: "#5a3d70" }}>
            A simple, digital-first process that gets you into the right car without long-term debt or complicated fine print.
          </p>
        </div>

        {/* Step cards — 3 columns matching original */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="p-5 rounded-lg"
                style={{
                  border: "1.5px solid #e6531e",
                  backgroundColor: "#ffffff",
                }}
              >
                {/* Step badge */}
                <div className="mb-3">
                  <span className="step-badge">{step.number}</span>
                </div>
                {/* Icon + title */}
                <div className="flex items-center gap-2 mb-2">
                  <Icon className="w-5 h-5 flex-shrink-0" style={{ color: "#e6531e" }} />
                  <h3 className="text-base font-semibold" style={{ color: "#2e004f" }}>
                    {step.title}
                  </h3>
                </div>
                {/* Description */}
                <p className="text-sm leading-relaxed" style={{ color: "#5a3d70" }}>
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={() => scrollTo("#vehicles")}
            className="btn-orange"
          >
            Start Your Application
          </button>
        </div>
      </div>
    </section>
  );
}
